<script setup lang="ts">
defineProps<{
  useMask?: boolean | null
  image?: Media | null
  maskedMedia?: {
    file?: Media | null
    maskShape?: MaskShape | null
  } | null
  /**
   * Classes for the <img> itself. Fallthrough attributes land on whatever the
   * branch renders — for a mask that is the shape's box, not the image inside
   * it — so anything that has to reach the image (object-fit, above all) comes
   * through here instead.
   */
  imageClass?: string | null
}>()

// The template is a v-if chain, so Vue has no single root to fall attributes
// through to and drops them silently — the branches take them by hand instead.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <core-mask-shape
    v-if="useMask && maskedMedia?.maskShape"
    :mask-shape="maskedMedia.maskShape"
    :image="maskedMedia.file"
    :image-class="imageClass"
    v-bind="$attrs"
  />
  <core-image
    v-else-if="image"
    :image="image"
    :class="imageClass"
    v-bind="$attrs"
  />
</template>
